import React, { createContext, useContext, useEffect, useState } from "react";
import api, { saveFirmAuth, clearFirmAuth } from "../lib/api";
import { pushLogout } from "../lib/push";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [team, setTeam] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("lm_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((e) => { setUser(false); if (e?.response?.status === 401) localStorage.removeItem("lm_token"); });
  }, []);

  useEffect(() => {
    if (user && user.tenant_role !== "client" && user.platform_role !== "owner") api.get("/team").then((r) => setTeam(r.data)).catch(() => {});
  }, [user]);

  // Remember the firm the user belongs to so that when an iOS/Android home-screen
  // shortcut reopens a deep (logged-out) firm URL, Protected can send them to THEIR
  // branded login instead of the generic Lexarra login.
  useEffect(() => {
    try {
      if (user && user.slug && user.tenant_role && user.platform_role !== "owner") {
        localStorage.setItem("lx_firm_slug", user.slug);
        localStorage.setItem("lx_firm_role", user.tenant_role);
      }
    } catch (e) { /* noop */ }
  }, [user]);

  const login = async (email, password, captcha, scope, extra) => {
    const { data } = await api.post("/auth/login", { email, password, ...(captcha || {}), ...(scope ? { scope } : {}), ...(extra || {}) });
    saveFirmAuth(data);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const setUserFromToken = (u) => setUser(u);

  const logout = async () => {
    const rt = localStorage.getItem("lm_refresh");
    const wasPlatform = !!(user && user.platform_role === "owner");
    await pushLogout();
    api.post("/auth/logout", { refresh_token: rt }).catch(() => {});
    clearFirmAuth();
    setUser(false);
    // Platform owners log in at /x1 — send them back there, not a stale firm slug.
    let target = wasPlatform ? "/x1" : "/login";
    try {
      if (!wasPlatform) {
        const slug = localStorage.getItem("lx_firm_slug");
        const role = localStorage.getItem("lx_firm_role");
        if (slug) target = role === "client" ? `/${slug}/portal` : `/${slug}/admin`;
      }
    } catch (e) { /* noop */ }
    window.location.href = target;
  };

  return (
    <AuthContext.Provider value={{ user, team, login, logout, setUserFromToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
